<template>
    <!--下单成功-->
    <div class="success-box">
        <img src="../../assets/success.png"/>

        <div class="order">恭喜您！订单提交成功！</div>
        <div class="number">订单号：{{ orderNumber }}</div>
        <div v-if="tipMsg" class="send">预计{{ data }}安排配送</div>
<!--        <div v-else class="tipMsg">尊敬的客户，您好，由于20号是春节前最后工作日，因此本日订单配送时间请以益力多姐姐沟通为准，谢谢您的理解。</div>-->
        <div class="delivery-info">
            <div class="info-title">配送说明</div>
            <div class="info-content">所有兑换（抽奖）的益力多产品均随正常订单一同配送，其他礼品方面会根据库存调配的时间，由配送的益力多姐姐与您协商，并尽快给您配送</div>
        </div>

        <div v-if="!freed" class="send">支付方式：</div>
        <div v-if="!freed" class="send">与益力多姐姐现金交易</div>

        <div class="success-btn">
            <div class="left" @click="handleLook(orderId)">查看详情</div>
            <div class="right" @click="handleOrder">继续下单</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OrderSuccess",

        data() {
            return {
                orderId: this.$route.query.orderId,
                orderNumber: this.$route.query.orderNumber,
                data: this.$route.query.orderData,
                freed: this.$route.query.freed,
                tipMsg: true
            }
        },

        mounted() {
            let nowTime = new Date().getTime();
            if (nowTime >= 1674144000000 && nowTime <= 1674230399000) {
                this.tipMsg = false;
            } else {
                this.tipMsg = true;
            }
        },

        methods: {
            handleLook(orderId) {
                let status = '未配送';
                this.$router.push({path: '/orderDetail', query:{orderId, status}})
            },

            handleOrder() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .success-box {
        color: #ea2d53;
        position: absolute;
        height: 96%;
        font-size: 0.7rem;
        border: 2px solid #ea2d53;
        border-radius: 10px;
        margin: 10px;
        background: #faf0eb;

        img {
            width: 100%;
        }

        .order {
            font-size: 1.3rem;
            margin-top: 30px;
        }

        .number {
            margin-top: 20px;
            font-size: 1rem;
            margin-bottom: 10px;
        }

        .send {
            margin-top: 20px;
            font-weight: bold;
            font-size: 1.3rem;
        }

        .tipMsg {
            margin-top: 15px;
            font-size: 1.1rem;
            font-weight: 700;
            line-height: 1.5rem;
            margin-left: 15px;
            margin-right: 15px;
        }

        .delivery-info {
            margin: 20px 15px;
            padding: 15px;
            background: #fff;
            border-radius: 8px;
            border-left: 4px solid #ea2d53;
            box-shadow: 0 2px 10px rgba(234, 45, 83, 0.1);

            .info-title {
                font-size: 0.9rem;
                font-weight: bold;
                color: #ea2d53;
                margin-bottom: 10px;
            }

            .info-content {
                font-size: 0.8rem;
                color: #666;
                line-height: 1.8;
                text-align: left;
            }
        }

        .success-btn {
            margin-top: 30px;
            color: #ea2d53;
            font-size: 1rem;
            div{
                border-radius: 5px;
                border: 1px solid #ea2d53;
                padding: 8px 25px;
            }
            .left {
                float: left;
                margin-left: 30px;
            }

            .right {
                float: right;
                margin-right: 30px;
            }
        }

    }

</style>